import { HelpPage } from "./help-model";

const text = 
`**Popups**
- **S** Abrir pop-up de Classificação 
- **F** Abrir pop-up dos filtros

**Navegação**
- **I** Inverter ordenação atual
- **Espaço** Selecionar a próxima empresa
- **⇨** Selecionar a próxima empresa
- **⇦** Selecionar a empresa anterior

**Outros**
- **M** Modo de verificação de metas  
Remove o agrupamento por região e ordena por *Meta Proporcional*.
- **T** Vai para o modo de visão em tabela
- **B** Popup de links em série para todas as contas visíveis *(ads lib, ads manager e billing)*`



export const shortcutHelp = {
    title: "Atalhos",
    body: text
} as HelpPage